import { render, staticRenderFns } from "./CMRemindSettingList.vue?vue&type=template&id=70018297&"
import script from "./CMRemindSettingList.vue?vue&type=script&lang=js&"
export * from "./CMRemindSettingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70018297')) {
      api.createRecord('70018297', component.options)
    } else {
      api.reload('70018297', component.options)
    }
    module.hot.accept("./CMRemindSettingList.vue?vue&type=template&id=70018297&", function () {
      api.rerender('70018297', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/CMRemindSettingList.vue"
export default component.exports